import React from 'react'
import nbaLogo from "../assets/nba-logo.png"
import { Container, Image } from "react-bootstrap";


const Header = () => {
  return (
    <Container className='text-center'>
      <Image src={nbaLogo} alt="nba-logo" width="200" className='text-center'></Image>
      <h1 className="text-center fw-bold display-3 my-3">NBA Legends</h1>
    </Container>
    
  );
}

export default Header
